export const PRODUCT_STATUS_STYLES = {
  isPosted: "isPosted",
  notPosted: "notPosted",
};
